import { ProofOfDeliveryModel } from "../apiModels/proofOfDeliveryModel";
import { ProofOfDeliveryRequestModel } from "../apiModels/proofOfDeliveryRequestModel";
import apiPaths from "./apiPaths";
import { get, post } from "./apiUtilities";

export const requestProofOfDelivery = async (request: ProofOfDeliveryRequestModel) => await post(apiPaths.requestProofOfDelivery, {
    body: JSON.stringify(request)
});

export const getAllProofOfDeliveryForShipment = async (shipmentTrackingNumber: string) => await get<ProofOfDeliveryModel[]>(`${apiPaths.getProofOfDeliveryForShipment}/${shipmentTrackingNumber}`);